// extracted by mini-css-extract-plugin
export default {"upgrades":"CwuPM","upgradePrice":"NSRht"};